import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BENEFIT_BOOKING, GET_BENEFIT_BOOKING_SUCCESS, GET_BENEFIT_BOOKING_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getBenefitBooking({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { membershipId, benefitConfigId,page_size, page_index } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/booking-event-data?page_size=${page_size}&page_index=${page_index}&membership_id=${membershipId}&benefit_group_id=${benefitConfigId}`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFIT_BOOKING_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFIT_BOOKING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_BOOKING_ERROR, payload: error });
  }
}

export function* watchGetBenefitBooking() {
  yield takeEvery(GET_BENEFIT_BOOKING, getBenefitBooking);
}

function* getBenefitBookingSaga() {
  yield all([fork(watchGetBenefitBooking)]);
}

export default getBenefitBookingSaga;
